// features/admin/adminSaga1.js
import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchStoresFailure,
  fetchStoresRequest,
  fetchStoresSuccess,
  createStoreFailure,
  createStoreRequest,
  createStoreSuccess,
  updateStoreRequest,
  updateStoreSuccess,
  deleteStoreRequest,
  deleteStoreSuccess,
  deleteStoreFailure,
  updateStoreFailure,
} from "../StoreList/StoreSlice";
import axios from "axios";

// Fetch Admins
function* fetchStores(action) {
  try {
    const payload = action.payload || { start: 1, limit: 5, search: "" };

    const response = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/store/getStoreList`,
        { params: payload }
      )
    );

    const result = response.data;
    const stores = result.data?.data || [];
    const total = result.data?.total || 0;
    const page = result.data?.page || 1;
    const limit = result.data?.limit || 5;

    const storesArray = stores.map((store, index) => ({
      id: (payload.page - 1) * payload.limit + index + 1,
      _id: store._id,
      branchName: store.branchName,
      branchCode: store.branchCode,
      phone: store.phone,
      area: store.area,
      address1: store.address1,
      address2: store.address2,
      address3: store.address3,
      city: store.city,
      state: store.state,
      pincode: store.pincode,
      email: store.email,
      managerName: store.managerName,
      countryCode: store.countryCode,
      createdBy: store.createdBy || "",
      updatedBy: store.updatedBy || "",
      status:store.status,
    }));

    yield put(
      fetchStoresSuccess({
        data: storesArray,
        total,
        page,
        limit,
      })
    );
  } catch (error) {
    console.error("Store list fetch failed:", error);
    yield put(
      fetchStoresFailure(error.response?.data?.message || error.message)
    );
  }
}

// Create Admin
function* createStore(action) {
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/store/createStore`,
      action.payload,

      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    console.log(
      "Createstore",
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/store/createStore`
    );
    yield put(createStoreSuccess(response.data));
    // Optionally refresh list
    yield put(fetchStoresRequest());
    console.log("post api information", response.data);
  } catch (error) {
    yield put(
      createStoreFailure(error.response?.data?.message || error.message)
    );
  }
}

// Edit
function* updateStore(action) {
  try {
    const { _id, ...storeData } = action.payload;

    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/store/storeEditPatch/${_id}`,
      storeData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    yield put(updateStoreSuccess(response.data));
    // Optionally refresh list
    yield put(fetchStoresRequest());
    console.log("edit store response:", response.data);
  } catch (error) {
    yield put(
      updateStoreFailure(error.response?.data?.message || error.message)
    );
  }
}

function* deleteStore(action) {
  try {
    const storeId = action.payload;

    yield call(
      axios.delete,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/store/storeDelete/${storeId}`
    );
    console.log(
      "deltestore",
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/storeDelete/${storeId}`
    );

    yield put(deleteStoreSuccess(storeId));
    yield put(fetchStoresRequest()); // Refresh list
    console.log("Deleted store:", storeId);
  } catch (error) {
    yield put(
      deleteStoreFailure(error.response?.data?.message || error.message)
    );
  }
}
export default function* storeSaga() {
  yield takeLatest(fetchStoresRequest.type, fetchStores);
  yield takeLatest(createStoreRequest.type, createStore); // <- Add this
  yield takeLatest(updateStoreRequest.type, updateStore);
  yield takeLatest(deleteStoreRequest.type, deleteStore); // ✅ Added here
}
